import {  Component, Input, Output, EventEmitter, OnInit, OnChanges, ChangeDetectionStrategy, SimpleChange,
          ElementRef } from '@angular/core';
import { FormControl, ReactiveFormsModule, FormGroup } from '@angular/forms';

import { TaskItem, TaskChangeRequest } from '../app.interfaces';

@Component({
  selector: 'mcrit-time-table-dialog',
  templateUrl: './week-time-table-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./week-time-table-dialog.component.scss']
})
export class WeekTimeTableDialogComponent implements OnChanges, OnInit {
  @Input() tasks: Array<TaskItem> = [];
  @Input() projectId: number;
  @Input() selectedDay: string;

  @Output() update: EventEmitter<TaskChangeRequest> = new EventEmitter();
  @Output() close: EventEmitter<{}> = new EventEmitter();

  public tasksForm: { [key: string]: FormGroup };
  public taskList: Array<TaskItem> = [];
  public last:any;

  public hide(): void {
    this.elementRef.nativeElement.style.display = 'none';
  }

  public show(): void {
    this.updateForms();
    this.elementRef.nativeElement.style.display = 'block';
  }

  private updateForms(): void {
    this.taskList = [...this.tasks, {
      id: 'NEW',
      projectId: this.projectId,
      authorId: 'SELF',
      date: (new Date(this.selectedDay)).toISOString().slice(0, 10),
      description: '',
      hours: 0
    }];

    this.tasksForm = this.taskList.reduce((
      acum: { [key: string]: FormGroup },
      curr: TaskItem
    ): { [key: string]: FormGroup } => {
      acum[curr.id] = new FormGroup({
        id: new FormControl(curr.id),
        projectId: new FormControl(curr.projectId),
        description: new FormControl(curr.description),
        date: new FormControl((new Date(curr.date)).toISOString().slice(0, 10)),
        authorId: new FormControl(curr.authorId),
        hours: new FormControl(curr.hours)
      });
      return acum;
    }, {});
  }

  public requestClose() {
    this.close.emit({});
  }

  public requestUpdate(action: 'ADD' | 'REMOVE' | 'UPDATE', id: string): void {
    this.update.emit({
      action: action,
      newState: <TaskItem> Object.assign({}, this.tasksForm[id].value)
    });
    this.hide();
  }

  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
    this.updateForms();
  }

  ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
    this.updateForms();
  }

}
